import { i18n } from '@lingui/core';
import { Popover } from '@material-ui/core';
import { t } from '@lingui/macro';
import { useRef, useState } from 'react';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';

import { useGlobalDataService } from '../../../services/ApiDataService';
import { addPlmPrefix, usePlmId } from '../../../utilities/PgmUtilities';

const useStyles = makeStyles((theme) => ({
    agentAddButtonContainer: {
        marginLeft: theme.spacing(1.5),

        '& .MuiButton-root': {
            marginLeft: 0,
        },
    },
}));

const mainButtonText = i18n._(t`Add`);
const finderButtonText = i18n._(t`Find Hardware nPoints`);
const downloadButtonText = i18n._(t`Download Virtual nPoint`);

export default function AgentListAddButtons({ handleDownloadClickFunc }) {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const globalDataService = useGlobalDataService();
    const plmId = usePlmId();

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const closeMenu = () => setOpen(false);

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    const handleFinderClick = async () => {
        closeMenu();

        let finderApi = '/api/v3/systemconfiguration/finderip';
        finderApi = plmId ? `/pgm${finderApi}` : finderApi;
        const { data: finderCfg } = await globalDataService.get(finderApi);

        const baseFinderPath = addPlmPrefix('/admin/nPoints/finder', plmId);
        let finderPath = `${window.location.protocol}//${window.location.host}${baseFinderPath}`;

        if (finderCfg?.hstsEnabled) {
            finderPath = `${window.location.protocol}//${finderCfg.nPointFinderHost}${baseFinderPath}`;
        }

        window.open(finderPath, '_blank', 'noopener,noreferrer');
    };

    const handleDownloadClick = () => {
        closeMenu();
        handleDownloadClickFunc();
    };

    return (
        <div className={classes.agentAddButtonContainer}>
            <Button
                variant="contained"
                color="primary"
                size="small"
                aria-controls={open ? 'split-button-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="menu"
                onClick={handleToggle}
                endIcon={<ArrowDropDownIcon />}
                ref={anchorRef}
            >
                {mainButtonText}
            </Button>
            <Popover
                open={open}
                anchorEl={anchorRef.current}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                        <MenuList id="split-button-menu">
                            <MenuItem onClick={handleDownloadClick}>{downloadButtonText}</MenuItem>
                            <MenuItem onClick={handleFinderClick}>{finderButtonText}</MenuItem>
                        </MenuList>
                    </ClickAwayListener>
                </Paper>
            </Popover>
        </div>
    );
}
